// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SharedContactPreferenceModel {
    static getAttributeTypeMap() {
        return SharedContactPreferenceModel.attributeTypeMap;
    }
}
SharedContactPreferenceModel.discriminator = undefined;
SharedContactPreferenceModel.additionalProperties = false;
SharedContactPreferenceModel.attributeTypeMap = [
    {
        "name": "contactInfoType",
        "baseName": "contactInfoType",
        "type": "ContactInfoType"
    },
    {
        "name": "isOptedIn",
        "baseName": "isOptedIn",
        "type": "boolean"
    },
    {
        "name": "isPreferred",
        "baseName": "isPreferred",
        "type": "boolean"
    },
];
//# sourceMappingURL=sharedContactPreferenceModel.js.map